import { render } from "./AddProceedingModal.vue?vue&type=template&id=7398d518&scoped=true"
import script from "./AddProceedingModal.vue?vue&type=script&lang=js"
export * from "./AddProceedingModal.vue?vue&type=script&lang=js"

import "./AddProceedingModal.vue?vue&type=style&index=0&id=7398d518&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7398d518"]])

export default __exports__